const getters = {
    getItemQuantity: (state) => (id_item) => {
      const cartItem = state.cart.items.find(item => item['id_Producto'] === id_item)
      if (cartItem) {
        if (cartItem['cantidad']) {
          return cartItem['cantidad']
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    getItemComments: (state) => (id_item) => {
      const cartItem = state.cart.items.find(item => item['id_Producto'] === id_item)
      if (cartItem) {
        if (cartItem['comentarios']) {
          return cartItem['comentarios']
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  }

export default getters